import dayjs from 'dayjs'
import { Format } from 'common/utils'
import { MailStatus } from 'common/types/enum'

export function parseMailStatus(
  status: MailStatus | undefined,
  expiry: string,
  address: string,
) {
  const prettyStatus = status?.split(':')?.[0]?.replace('.', '')
  let actualStatus: MailStatus | undefined = status
  switch (prettyStatus) {
    case 'Mail Ready': {
      actualStatus = MailStatus.CREATED
      break
    }
    case 'Forwarding Requested': {
      actualStatus = MailStatus.REQUESTED_FORWARD
      break
    }
    case 'Scan and Forward Complete': {
      actualStatus = MailStatus.FORWARDED
      break
    }
    case 'Forwarding Complete': {
      actualStatus = MailStatus.FORWARDED
      break
    }
    case 'Post Scanned':
    case 'Scan Complete': {
      actualStatus = MailStatus.SCANNED
      break
    }
    case 'Mail collected': {
      actualStatus = MailStatus.COLLECTED
      break
    }
    default: {
      actualStatus = status
      break
    }
  }

  switch (actualStatus) {
    case MailStatus.ACCOUNT_FROZEN:
      return 'Your account has been frozen, please contact us to regain access.'
    case MailStatus.COLLECTED:
      return 'Your mail has been collected.'
    case MailStatus.CREATED: {
      return `Mail items will be stored at no cost for 30 days. If you require a
              physical copy, please collect or request a Forward before ${dayjs(
                expiry,
              ).format('DD MMMM YYYY')}`
    }
    case MailStatus.DESTROYED:
      return 'As per the storage policy in our Terms and Conditions, this mail item was destroyed after 30 days'
    case MailStatus.FORWARDED: {
      const formattedAddress = address
        .split(/[\n\r]/g)
        .filter((v) => !!v)
        .map((v) => v.replace(',', ''))
        .join(', ')
      return `We have forwarded this mail item to ${formattedAddress}.`
    }
    case MailStatus.ON_HOLD_INVOICE:
      return 'Your mail is being held whilst you update your payment method.'
    case MailStatus.ON_HOLD_KYC_ID:
      return 'Your mail is being held whilst you verify your identity.'
    case MailStatus.PENDING:
    case MailStatus.PROCESSING:
      return 'Your mail is being processed.'
    case MailStatus.REFUSED:
      return 'This mail item has been refused by our agents.'
    case MailStatus.REJECTED:
      return 'This mail item has been rejected by our agents.'
    case MailStatus.REQUESTED_FORWARD:
    case MailStatus.REQUESTED_SCAN:
      return 'We are processing your request.'
    case MailStatus.RETURNED:
      return 'This mail item is not covered in your plan and has been returned to the sender.'
    case MailStatus.SCANNED:
      return 'Your mail is ready for download.'
    default:
      return `${Format.enumeration.get(prettyStatus)}`
  }
}

export function formatStatus(status: MailStatus | string | undefined) {
  switch (status) {
    case MailStatus.CREATED: {
      return `Ready`
    }
    case MailStatus.ON_HOLD_INVOICE:
      return 'Awaiting payment'
    case MailStatus.ON_HOLD_KYC_ID:
      return 'Awaiting identity verification'
    default:
      return `${Format.enumeration.get(status?.split?.(':')?.[0])}`
  }
}
